module.exports = __webpack_public_path__ + "static/media/website_banner.569fe43b.png";